import React from "react";
import Box from "@mui/material/Box";
import CustomModal from "@mui/material/Modal";

import { ModalProps } from "./Modal.props";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 840,
  width: "100%",
  bgcolor: "white",
  boxShadow: 24,
  p: "30px 40px",
  borderRadius: "20px",
  marginLeft: "0",
  marginRight: "0",
  zIndex: -1,
};

export const Modal: React.FC<ModalProps> = (props) => {
  const {
    open,
    children,
    handleClose,
    maxWidth,
    marginLeft = "0",
    marginRight = "0",
    sx,
  } = props;
  style.maxWidth = maxWidth ? maxWidth : style.maxWidth;
  style.marginLeft = marginLeft ? marginLeft : style.marginLeft;
  style.marginRight = marginRight ? marginRight : style.marginRight;
  return (
    <CustomModal open={open} onClose={handleClose}>
      <Box sx={sx ?? style} maxWidth={maxWidth}>
        {children}
      </Box>
    </CustomModal>
  );
};
